/* Defer video downloads until the viewer is near them.
   Videos keep their poster, so the section looks identical at rest; only the
   multi-megabyte download is postponed. No change to quality or dimensions. */
(function () {
  var vids = document.querySelectorAll('video[data-src]');
  if (!vids.length) return;

  function load(v) {
    if (v.dataset.loaded) return;
    v.dataset.loaded = '1';
    v.src = v.dataset.src;
    v.load();
    if (v.hasAttribute('data-autoplay')) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  if (!('IntersectionObserver' in window)) {
    vids.forEach(load);
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { load(e.target); io.unobserve(e.target); }
    });
  }, { rootMargin: '300px 0px' });   // start slightly before it scrolls in
  vids.forEach(function (v) { io.observe(v); });
})();
